module.exports = __webpack_public_path__ + "img/add-group.531bd85c.svg";